/**
 * @Description: 数字人配置（子菜单/快捷入口）相关接口
 * @Doc: 数字人配置（子菜单/快捷入口）接口文档.md
 * 基础路径：/sphere-admin/api/v1/sphere/agentConfig （SphereAgentConfigController）
 * 鉴权：请求头携带 Authorization（Bearer），由 clientRequest 统一注入
 */
import request from './clientRequest'

const AGENT_CONFIG_BASE = '/sphere-admin/api/v1/sphere/agentConfig'

/**
 * 1. 一键复制数字人配置
 * 将源数字人的子菜单和快捷入口复制到目标数字人（覆盖目标原有配置）
 * @param {Object} data 请求体
 * @param {Number|String} data.sourceAgentId 源数字人id（必填）
 * @param {Number|String} data.targetAgentId 目标数字人id（必填）
 * @returns {Promise} data 为 { targetAgentCount, targetAgentIds, menuCount, entryCount }
 */
export function copyAgentConfig(data) {
  return request({
    url: `${AGENT_CONFIG_BASE}/copy`,
    method: 'post',
    data
  })
}

/**
 * 2. 按模板同步数字人配置
 * 将模板数字人的子菜单和快捷入口同步到所有由该模板创建的数字人（覆盖其原有配置）
 * @param {Number|String} agentId 模板数字人id
 * @returns {Promise} data 为 { targetAgentCount, targetAgentIds, menuCount, entryCount }
 */
export function syncAgentConfig(agentId) {
  return request({
    url: `${AGENT_CONFIG_BASE}/sync/${agentId}`,
    method: 'post'
  })
}
